import { GATEWAY_ORIGIN } from '@/constants/environment';

/**
 * Player API configuration constants
 */
export const PLAYER_API_CONFIG = {
  NAMESPACE: 'http://www.bewotec.de/bewotecws/Schema',
  TOUR_OPERATOR: 'VAMOS',
  DEFAULT_CURRENCY: 'EUR',
  DEFAULT_LANG: 'de',
  DEFAULT_TREE_ID: 1,
  DEFAULT_PRODUCT_TYPE: 'Hotel',
  ENDPOINT: `${GATEWAY_ORIGIN}/Bewo.Hub.Service/BewotecHubService.svc`,
  TIMEOUT: 30000,
  RETRY: {
    MAX_ATTEMPTS: 3,
    INITIAL_DELAY: 1000,
    MAX_DELAY: 10000,
    BACKOFF_FACTOR: 2,
  },
  CACHE: {
    AVAILABLE_VALUES_TTL: 60 * 60 * 1000,
    STORAGE_PREFIX: 'bewotec_cache_',
  },
  LIMITS: {
    MAX_ADULTS: 9,
    MAX_CHILDREN: 9,
    MAX_CHILD_AGE: 17,
    MIN_CHILD_AGE: 0,
    MAX_DURATION: 365,
  },
  ACTIONS: {
    GET_AVAILABLE_VALUES: 'BewotecHubService/GetAvailableValues',
    GET_PRODUCT_LIST: 'BewotecHubService/GetProductList',
    GET_PRODUCT_OFFERS: 'BewotecHubService/GetProductOffers',
  },
} as const;
